import { __assign } from "tslib";
/* eslint-disable no-console , camelcase */
import { getHighestQualityVideo, getFilePluginComponentData, } from '../uploadStrategy/uploadStrategy';
import { isSSR, IMAGE_TYPE, VIDEO_TYPE, FILE_UPLOAD_TYPE, } from 'wix-rich-content-common';
export default function mediaManagerStrategy(appDefId, hasPlugin) {
    var _a;
    var ModuleRegistry = !isSSR() ? window.ModuleRegistry : undefined;
    // Not in Business manager
    if (!ModuleRegistry || !appDefId)
        return {};
    var categories = ModuleRegistry.invoke('mediaManager.categories');
    if (!categories) {
        console.error('Media Manager is not available');
        return {};
    }
    var imageUpload = function (index, multiple, updateEntity) {
        ModuleRegistry.invoke('mediaManager.open', categories.IMAGE, appDefId, {
            multiSelect: multiple,
            onSuccess: function (data) {
                var imageData = data.items.map(function (_a) {
                    var id = _a.id, file_name = _a.fileName, height = _a.height, width = _a.width;
                    return ({
                        id: id,
                        height: height,
                        width: width,
                        original_file_name: file_name,
                        file_name: file_name,
                    });
                });
                updateEntity({
                    data: imageData,
                    index: index,
                });
            },
        });
    };
    var videoUpload = function (updateEntity) {
        ModuleRegistry.invoke('mediaManager.open', categories.VIDEO, appDefId, {
            onSuccess: function (data) {
                var _a = data.items[0].fileOutput, video = _a.video, image = _a.image;
                var pathname = getHighestQualityVideo(video).url;
                var _b = image[0], url = _b.url, width = _b.width, height = _b.height;
                var thumbnail = { pathname: url, width: width, height: height };
                updateEntity({ data: { pathname: pathname, thumbnail: thumbnail } });
            },
        });
    };
    var fileUpload = function (updateEntity) {
        ModuleRegistry.invoke('mediaManager.open', categories.ALL_MEDIA, appDefId, {
            onSuccess: function (data) {
                var _a = data.items[0], name = _a.title, mediaType = _a.mediaType, fileUrl = _a.fileUrl;
                var componentData = getFilePluginComponentData(name, mediaType, fileUrl);
                updateEntity({ data: [componentData] });
            },
        });
    };
    return {
        helpers: __assign({}, (hasPlugin(IMAGE_TYPE) && { handleFileSelection: imageUpload })),
        config: (_a = {},
            _a[VIDEO_TYPE] = __assign({}, (hasPlugin(VIDEO_TYPE) && {
                handleFileSelection: videoUpload,
            })),
            _a[FILE_UPLOAD_TYPE] = __assign({}, (hasPlugin(FILE_UPLOAD_TYPE) && {
                handleFileSelection: fileUpload,
            })),
            _a),
    };
}
//# sourceMappingURL=mediaManagerStrategy.js.map